module.exports = __webpack_public_path__ + "images/radnicka_prava-6b08e462aabd36c965f809cfdc2ffeae.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/radnicka_prava.png
// module id = 53
// module chunks = 0